var bW = document.documentElement.clientWidth;
var bH = document.documentElement.clientHeight;
function resizeWindow(){
  bW = document.documentElement.clientWidth;
  bH = document.documentElement.clientHeight;
}

//ham
document.addEventListener('DOMContentLoaded', function() {
  var ham = document.querySelector('.c-ham');
  var nav = document.querySelector('.l-header nav');
  var body = document.querySelector('body');
  if(ham){
    ham.addEventListener('click', () => {
      ham.classList.toggle('ham-active');
      nav.classList.toggle('ham-active');
      body.classList.toggle('ham-active');
    });
  const navlinks = document.querySelectorAll('.l-header nav li a');
    navlinks.forEach(navlink =>{
      navlink.addEventListener('click', () => {
        ham.classList.toggle('ham-active');
        nav.classList.toggle('ham-active');
        body.classList.toggle('ham-active');
      });
    });
  };
});


//totop
window.addEventListener('scroll', function () {
  const totop = document.querySelector(".c-pageTop");
  const bodyHeight = document.body.clientHeight;
  const windowScrollHeight = document.documentElement.clientHeight + document.documentElement.scrollTop || document.body.scrollTop || document.scrollingElement.scrollTop || window.pageYOffset || window.scrollY;
  const footerHeight = document.querySelector('.l-footer').clientHeight;
  if (bodyHeight - windowScrollHeight <= footerHeight) {
    totop.style.position = 'absolute';
    totop.style.bottom = footerHeight + 16 + 'px';
  } else {
    totop.style.position = 'fixed';
    totop.style.bottom = '16px';
  }
  if(window.scrollY > 100){
    totop.classList.add('is-active');
  }else{
    totop.classList.remove('is-active');
  }
});
const pagetopBtn = document.querySelector('.c-pageTop');
pagetopBtn.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
});


//faq
document.addEventListener('DOMContentLoaded', () => {
  setupToggleDetailsAnimation();
});

function setupToggleDetailsAnimation() {
  const details = document.querySelectorAll('details.js-animation');
  details.forEach(elem => {
    const summary = elem.querySelector('summary');
    const content = elem.querySelector('.details-content');
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (elem.open) {
        const closeDetails = content.animate(
          {
            opacity: [1, 0],
            height: [content.offsetHeight + 'px', 0],
          },
          {
            duration: 300,
            easing: 'ease-in',
          }
        );
        const rotateIcon = summary.animate(
          { rotate: ["90deg", "0deg"] },
          {
            duration: 300,
            pseudoElement: "::before",
            easing: 'ease-in',
            fill: 'forwards',
          }
        );
        closeDetails.onfinish = () => {
          elem.removeAttribute('open');
        }
      } else {
        elem.setAttribute('open', 'true');
        const openDetails = content.animate(
          {
            opacity: [0, 1],
            height: [0, content.offsetHeight + 'px'],
          },
          {
            duration: 300,
            easing: 'ease-in',
          }
        );
        const rotateIcon = summary.animate(
          { rotate: ["0deg", "90deg"] },
          {
            duration: 300,
            pseudoElement: "::before",
            easing: 'ease-in',
            fill: 'forwards',
          }
        );
      }
    });
  });
}





document.getElementById('body').classList.add('show');